<template>
  <div class="hidden-sm-and-up bg">
    <div class="mobile_callme_wrap">
      <p>
        <span>利川市靓利建设工程有限公司</span>
        <span style="margin-left: 20px">版权公司所有</span>
        <span style="margin-left: 20px">公关备案1111111111</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    company() {
      return this.$store.state.company
    }
  }
}
</script>

<style lang="scss" scoped>
.bg{
  background: url('../../assets/images/home/callme2.jpg') 0 0 no-repeat;
  background-size: cover;
}
.mobile_callme_wrap{
  width: 100%;
  height: 100PX;
  margin-top: 20PX;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30PX;
  box-sizing: border-box;
  p{
    font-size: 12PX;
    color: #fff;
    line-height: 18PX;
  }
}
</style>